<template>
<div>
	<div v-if="timeline.length == 0">
		<p>No Events <template v-if="weeksBack">since {{ backUntilMoment.format("YYYY-MM-DD")}}</template></p>
		<p v-if="weeksBack"><router-link :to="'/project/' + job.slug + '/reports'">See Full Timeline</router-link></p>
	</div>
	<ul class="timeline-list">
		<button v-if="weeksBack" type="button" class="btn-light" title="Load previous 4 weeks" v-on:click="loadMoreBack">
			<i class="fa fa-caret-left"></i>
		</button>
		<li v-for="(day,index) in timeline" 
			:title="day.blockDate" 
			class="timeline-day"
			:class="{
				'filler-day' : day.fillerDay,
				'timeline-start' : index == 0,
				'timeline-end' : index == selectedHourBlocks.length - 1
			}"
			v-on:click="dayClick(index)">

			<template v-if="!day.fillerDay && day.events.length > 0">
				<i class="fa fa-circle" ></i>
				<span>{{ moment(day.blockDate).format("MM-DD") }}</span>
			</template>	
		</li>
	</ul>

	<div v-if="selectedDay && selectedHourBlocks">
		<div class="d-flex justify-content-between">
			<h4>{{ selectedDay }}</h4>
			<i class="fa fa-times icon-button" v-on:click="selectedDay = false"></i>
		</div>

		<ul class="timeline-list">
			<li v-for="(block,index) in selectedHourBlocks" 
				:title="blockIndexToTimeLabel(block.block)" 
				class="timeline-block" 
				:class="{
					'timeline-start' : index == 0,
					'timeline-end' : index == selectedHourBlocks.length - 1
				}"
				v-on:click="blockClick(index)">

				<i class="fa fa-circle" v-if="block.blockEvents.length > 0"></i>
				<span>{{ blockIndexToTimeLabel(block.block) }}</span>
			</li>
		</ul>

		<table-list v-if="selectedDay"
			record-name="Event"
			:fields="[
				{label: '', key: 'typeIcon'},
				{label: 'Date/Time', key: 'dateTimeFormatted'},
				{label: 'Event', key: 'description'}
			]"
			:records="mutatedBlockEvents">

			<h4>{{ selectedDay }} <template v-if="selectedHour">{{ blockIndexToTimeLabel(selectedHour) }}</template></h4>

		</table-list>
	</div>
</div>
</template>

<script type="text/javascript">

import TableList from "@/components/TableList"

export default {
	name: "JobTimeline",
	props: ["job","jobType","weeksBack"],
	components: {
		TableList
	},
	data() {
		return {
			trackerActivity: [],
			timelogs: [],
			worksheets: [],
			completedForms: [],
			events: [],
			selectedDay: null,
			selectedHourBlocks: [],
			selectedHour: null,
			selectedHourEvents: [],
			loadFrom: null,
			loadTo: this.moment().format("YYYY-MM-DD")
		}
	},
	watch: {
		job() {
			this.fetchData()
		}
	},
	computed: {
		backUntilMoment() {
			let vm = this
			if (!this.weeksBack) {
				return vm.moment.utc(this.$store[vm.jobType].created_at).local()
			}
			else {	
				let backUntilMoment = vm.moment().subtract(+this.weeksBack * 7,"days").local()

				return backUntilMoment
			}
		},
		fromDateTime() {
			let fromDateTime = this.backUntilMoment.format("YYYY-MM-DD")
			if (this.loadFrom)
				fromDateTime = this.loadFrom

			return fromDateTime
		},
		toDateTime() {
			let toDateTime = this.moment().format("YYYY-MM-DD")
			if (this.loadTo)
				toDateTime = this.loadTo 

			return toDateTime
		},
		timeline() {
			let vm = this

			let dailyBlocks = []

			let jobKey = "service_id"
			if (this.jobType == 'project')
				jobKey = "job_id"

			let today = vm.moment().add(1,"days")

			let backUntilMoment = vm.backUntilMoment.clone()

			for (var m = backUntilMoment; m.isSameOrBefore(today); m.add(1,"days")) {

				let events = []
				vm.trackerActivity.forEach(device => {
					device.log.forEach(logEntry => {
						if (vm.moment.utc(logEntry.dateTime).local().format("YYYY-MM-DD") == m.format("YYYY-MM-DD")) {
							let eventDescription = ""
							let equipment = vm.$store.equipments.find(eq => eq.geotab_entity_id == device.id)	

							if (equipment)
								eventDescription = equipment.description

							if ("crossedBoundary" in logEntry && logEntry.crossedBoundary && logEntry.distance < vm.job.check_in_tolerance)
								eventDescription += " arrived on site at " + vm.moment.utc(logEntry.dateTime).local().format("HH:mm A")
							else if ("crossedBoundary" in logEntry && logEntry.crossedBoundary && logEntry.distance > vm.job.check_in_tolerance)
								eventDescription += " left the job site at " + vm.moment.utc(logEntry.dateTime).local().format("HH:mm A")

							events.push({
								description: eventDescription,
								type: 'Equipment',
								dateTime: logEntry.dateTime
							})
						}
					})
				})

				vm.timelogs.forEach(timelog => {
					if (vm.moment.utc(timelog.time_in).local().format("YYYY-MM-DD") == m.format("YYYY-MM-DD")) {
						events.push({
							description: timelog.User.first_name + " " + timelog.User.last_name + " clocked into the job",
							type: "TimeLog",
							dateTime: timelog.time_in
							
						})
					}
					if (vm.moment.utc(timelog.time_out).local().format("YYYY-MM-DD") == m.format("YYYY-MM-DD")) {
						events.push({
							description: timelog.User.first_name + " " + timelog.User.last_name + " clocked out of the job",
							type: "TimeLog",
							dateTime: timelog.time_out
							
						})
					}
				})

				vm.worksheets.forEach(ws => {
					if (vm.moment.utc(ws.created_at).local().format("YYYY-MM-DD") == m.format("YYYY-MM-DD")) {
						events.push({
							description: "Worksheet created by " + ws.WorkCompletedBy.first_name + " " + ws.WorkCompletedBy.last_name,
							type: "Worksheet",
							dateTime: ws.created_at
							
						})
					}
				})

				vm.completedForms.forEach(form => {
					if (vm.moment.utc(form.created_at).local().format("YYYY-MM-DD") == m.format("YYYY-MM-DD")) {
						events.push({
							description: "Company Form (" + form.FormTemplate.title + ") created by " + form.UpdatedBy.first_name + " " + form.UpdatedBy.last_name,
							type: "CompanyForm",
							dateTime: form.created_at
							
						})
					}
				})

				vm.flattenedFormAcknowledgements.forEach(ack => {
					if (vm.moment.utc(ack.completed_at).local().format("YYYY-MM-DD") == m.format("YYYY-MM-DD")) {
						events.push({
							description: "Company Form (" + ack.CompanyForm.FormTemplate.title + ") acknowledged by " + ack.User.first_name + " " + ack.User.last_name,
							type: "CompanyFormAcknowledgement",
							dateTime: ack.completed_at
							
						})
					}
				})

				vm.events.forEach(event => {
					if (vm.moment.utc(event.start_time).local().format("YYYY-MM-DD") == m.format("YYYY-MM-DD")) {
						
						let description = ""
						let jobLabel = "Project"
						if (vm.jobType == 'service')
							jobLabel = "Service"

						if (event[jobKey] > 0) {

							if (event.user_id == 0 && event.equipment_id == 0) {
								description = jobLabel + " scheduled to start for the day" 

								events.push({
									description,
									type: "ScheduleEvent",
									dateTime: event.start_time
									
								})
							}
							else if (event.user_id > 0 && "User" in event && event.User) {
								description = event.User.first_name + " " + event.User.last_name + " scheduled to start for the day" 

								events.push({
									description,
									type: "ScheduleEvent",
									dateTime: event.start_time
									
								})
							}
							else if (event.equipment_id > 0 && "Equipment" in event && event.Equipment) {
								description = event.Equipment.description + " scheduled to start for the day" 

								events.push({
									description,
									type: "ScheduleEvent",
									dateTime: event.start_time
									
								})
							}
						}

					}
					if (vm.moment.utc(event.end_time).local().format("YYYY-MM-DD") == m.format("YYYY-MM-DD")) {
						
						let description = ""
						let jobLabel = "Project"
						if (vm.jobType == 'service')
							jobLabel = "Service"

						if (event[jobKey] > 0) {

							if (event.user_id == 0 && event.equipment_id == 0) {
								description = jobLabel + " scheduled to end for the day" 

								events.push({
									description,
									type: "ScheduleEvent",
									dateTime: event.end_time
									
								})
							}
							else if (event.user_id > 0 && "User" in event && event.User) {
								description = event.User.first_name + " " + event.User.last_name + " scheduled to end for the day" 

								events.push({
									description,
									type: "ScheduleEvent",
									dateTime: event.end_time
									
								})
							}
							else if (event.equipment_id > 0 && "Equipment" in event && event.Equipment) {
								description = event.Equipment.description + " scheduled to end for the day" 

								events.push({
									description,
									type: "ScheduleEvent",
									dateTime: event.end_time
									
								})
							}
							
						}
					}
				})

				events.sort((a,b) => {
					if (vm.moment(a.dateTime).isAfter(vm.moment(b.dateTime)))
						return 1
					else
						return -1
				})

				dailyBlocks.push({
					blockDate: m.format("YYYY-MM-DD"),
					events,
					fillerDay: false
				})

			}

			let condensed = dailyBlocks.filter((day,index) => {
				if (day.events.length > 0)
					return true
			})

			let mutated = [], nextDay
			condensed.forEach((day,index) => {
				if (index <= condensed.length - 2)
					nextDay = condensed[index + 1]

				if (index == 0 && vm.moment(day.blockDate).isAfter(vm.moment(vm.job.created_at))) {
					mutated.push({
						blockDate: vm.moment(vm.job.created_at).format("YYYY-MM-DD"),
						events: [],
						fillerDay: true
					})

				}
				mutated.push(day)

				if (nextDay && vm.moment(nextDay.blockDate).diff(vm.moment(day.blockDate),"days") > 1) {
					mutated.push(
						{
							blockDate: vm.moment(day.blockDate).add(1,"days").format("YYYY-MM-DD"),
							events: [],
							fillerDay: true
						}
					)
				}
			})

			/*
			if (mutated.length > 0 && this.moment(mutated[mutated.length - 1].blockDate).isBefore(this.moment())) {
				mutated.push(
					{
						blockDate: vm.moment().format("YYYY-MM-DD"),
						events: [],
						fillerDay: true
					}
				)
			}
			*/

			return mutated
		},
		mutatedBlockEvents() {

			function mutateEvent(event) {
				event.dateTimeFormatted = ""
				if ("dateTime" in event)
					event.dateTimeFormatted = vm.formatDateTimeToLocal(event.dateTime)

				event.typeIcon = ""
				if (event.type == 'TimeLog')
					event.typeIcon = "<i class='fa fa-clock'></i>"
				else if (event.type == 'Equipment')
					event.typeIcon =  "<i class='fa fa-truck'></i>"
				else if (event.type == 'Worksheet')
					event.typeIcon =  "<i class='fa fa-hammer'></i>"
				else if (event.type == 'CompanyFormAcknowledgement')
					event.typeIcon =  "<i class='fa fa-signature'></i>"
				else if (event.type == 'CompanyForm')
					event.typeIcon =  "<i class='fa fa-file-alt'></i>"
				else if (event.type == 'ScheduleEvent')
					event.typeIcon =  "<i class='fa fa-calendar'></i>"

				return event
			}

			let vm = this
			if (!this.selectedHour && this.selectedDay) {
				let selectedDay = this.timeline.find(day => day.blockDate == this.selectedDay)

				if (selectedDay)
					return selectedDay.events.map(event => mutateEvent(event))
				else
					return []
			}
			else if (this.selectedHour) {
				return this.selectedHourEvents.map(event => mutateEvent(event))
			}
			else return []
		},
		flattenedFormAcknowledgements() {
			let vm = this

			let acks = []
			this.completedForms.forEach(form => {
				if ("CompanyFormAcknowledgement" in form && form.CompanyFormAcknowledgement && form.CompanyFormAcknowledgement.length > 0) {
					form.CompanyFormAcknowledgement.forEach(ack => {
						ack.CompanyForm = form

						acks.push(ack)
					})
				}
			})

			return acks
		}
	},	
	methods: {
		loadMoreBack() {
			//increment back 4 weeks

			if (this.loadFrom)
				this.loadTo = this.loadFrom
			else
				this.loadTo = this.backUntilMoment.format("YYYY-MM-DD")

			if (this.loadFrom)
				this.loadFrom = this.moment(this.loadFrom).subtract(4 * 7,"days").format("YYYY-MM-DD")
			else
				this.loadFrom = this.backUntilMoment.subtract(4 * 7,"days").format("YYYY-MM-DD")

			this.fetchData(true)
		},
		dayClick(index) {
			if (this.timeline[index].events.length > 0) {
				this.selectedDay = this.timeline[index].blockDate
				this.selectedHourBlocks = this.hourlyTimelineBlocks(this.timeline[index])
				this.selectedHour = null
			}
		},
		blockClick(index) {
			this.selectedHour = this.selectedHourBlocks[index].block
			this.selectedHourEvents = this.selectedHourBlocks[index].blockEvents
		},
		hourlyTimelineBlocks(events) {
			let vm = this, hourBlocks = []

			if (events && "events" in events) {
				for (var block = 0; block < 24 * 4; block++) {
					let blockEvents = []
					events.events.forEach(event => {

						let eventTimeBlockEquivalent

						let hour = +vm.moment.utc(event.dateTime).local().format("H")
						let minute = +vm.moment.utc(event.dateTime).local().format("m")

						let minuteBlock
						if (minute < 15)
							minuteBlock = 0
						else if (minute < 30)
							minuteBlock = 1
						else if (minute < 45)
							minuteBlock = 2
						else
							minuteBlock = 3

						eventTimeBlockEquivalent = (hour * 4) + minuteBlock

						if (block == eventTimeBlockEquivalent) {

							blockEvents.push({
								description: event.description,
								type: event.type,
								dateTime: event.dateTime
							})
						}
					})

					hourBlocks.push({
						block,
						blockEvents
					})
				}
			}
			return hourBlocks
		},
		blockIndexToTimeLabel(index) {
			let hour = Math.floor(index / 4)

			let remainder = index % 4
			let minutes = ""

			if (remainder == 0)
				minutes = ":00"
			else if (remainder == 1)
				minutes = ":15"
			else if (remainder == 2)
				minutes = ":30"
			else if (remainder == 3)
				minutes = ":45"

			return hour + minutes
		},
		noEventsBeforeOrAfter(index) {
			if (index == 0 || index == this.timeline.length - 1)
				return false

			if (this.timeline[index - 1].events.length == 0 && this.timeline[index + 1].events.length == 0 && this.timeline[index].events.length == 0)
				return true

			return false
		},
		fetchNearbyTrackers(append) {
			let vm = this

			let params = {
				lat: vm.job.lat,
				long: vm.job.long,
				radius: vm.job.check_in_tolerance,
				fromDateTime: vm.fromDateTime,
				toDateTime: vm.toDateTime,
				onlyBoundaryCrossings: true
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("TrackingDevice/get-geofence-activity",params).then(response => {
					if (response.success) {
						if (append) {
							vm.trackerActivity = [
								...response.data,
								...vm.trackerActivity
							]
						}
						else
							vm.trackerActivity = response.data
					}

					resolve(response)
				})
			})
		},
		fetchTimeLogs(append) {
			let vm = this

			let jobKey = "service_id"
			if (this.jobType == 'project')
				jobKey = "job_id"

			let params = {
				include: [{
					model: "User",
					fields: ["id","slug","first_name","last_name"]
				}]
			}

			params.filters = [
				[jobKey,this.job.id],
				["time_in >=", this.fromDateTime],
				["time_in <=", this.toDateTime]
			]

			return new Promise((resolve,reject) => {
				this.getJSON("TimeLog/get",params).then(response => {
					if (response.success) {
						if (append) {
							vm.timeLogs = [
								...response.data,
								...vm.timelogs
							]
						}
						else
							vm.timelogs = response.data
					}
					
					resolve(response)
				})
			})
		},
		fetchWorksheets(append) {
			let vm = this

			let jobKey = "service_id"
			let resource = "ServiceWorksheet"
			if (this.jobType == 'project') {
				jobKey = "job_id"
				resource = "ChangeWorksheet"
			}

			let params = {
				filters: [
					[jobKey,this.job.id],
					["created_at >=", this.fromDateTime],
					["created_at <=", this.toDateTime]
				],
				include: ["User"]
			}

			return new Promise((resolve,reject) => {
				this.getJSON(resource + "/get",params).then(response => {
					if (response.success) {

						if (append) {
							vm.worksheets = [
								...response.data,
								...vm.worksheets
							]
						}
						else
							vm.worksheets = response.data
					}

					resolve(response)
				})
			})
		},
		fetchCompletedForms(append) {
			let vm = this

			let jobKey = "service_id"
			if (this.jobType == 'project') 
				jobKey = "job_id"

			let params = {
				filters: [
					[jobKey,this.job.id],
					["created_at >=", this.fromDateTime],
					["created_at <=", this.toDateTime]
				],
				include: [
					{model: "User", fields: ["id","slug","first_name","last_name"]},
					{model: "FormTemplate", fields: ["id","slug","created_at","title"]},
					{
						model: "CompanyFormAcknowledgement",
						include: [{model: "User", fields: ["id","slug","first_name","last_name"]}],
					}
				]
			}

			return new Promise((resolve,reject) => {
				this.getJSON("CompanyForm/get",params).then(response => {
					if (response.success) {
						if (append) {
							vm.completedForms = [
								...response.data,
								...vm.completedForms
							]
						}
						else {
							vm.completedForms = response.data
						}
					}

					resolve(response)
				})
			})
		},
		fetchEvents(append) {
			let vm = this

			let jobKey = "service_id"
			if (this.jobType == 'project') 
				jobKey = "job_id"

			let params = {
				filters: [
					[jobKey,this.job.id],
					["start_time >=", this.fromDateTime],
					["start_time <=", this.toDateTime]
				],
				include: [
					{model: "User", fields: ["id","slug","first_name","last_name"]},
					{model: "Equipment", fields: ["id","slug","description"]},
				]
			}

			return new Promise((resolve,reject) => {
				this.getJSON("ScheduleEvent/get",params).then(response => {
					if (response.success) {
						if (append) {
							vm.events = [
								...response.data,
								...vm.events
							]
						}
						else
							vm.events = response.data
					}

					resolve(response)
				})
			})
		},
		fetchData(append) {
			let vm = this

			this.spinner(true)

			let promises = [
				this.fetchWorksheets(append),
				this.fetchTimeLogs(append),
				this.fetchNearbyTrackers(append),
				this.fetchEquipment(),
				this.fetchCompletedForms(append),
				this.fetchEvents(append)
			]

			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {
					vm.spinner(false)
					resolve(responses)
				})
			})
		}
	},
	created() {
		if (this.job) {
			this.fetchData()
		}
	}
}
</script>

<style scoped>
	.timeline-list {
		list-style: none;
		padding: 0;
		display: flex;
		flex-wrap: wrap;

	}

	.timeline-list li {
		display: inline-block;
		cursor: pointer;
		margin-left: -1px;
		margin-right: -1px;
		position: relative;
		min-width: 50px;
		height: 40px;
		margin: 0;
		padding: 1px;
		padding-left: 0;
		padding-right: 0;
		border-top: 3px solid black;
		position: relative;
		text-align: center;
		flex-grow: 1;
	}

	.timeline-list li.timeline-day.filler-day {
		border-top: 3px dotted black;
	}

	.timeline-list li.timeline-start {
		border-left: 3px solid black;
	}

	.timeline-list li.timeline-end {
		border-right: 3px solid black;
	}

	.timeline-list .line {
		height: 3px;
		width: 100%;
		background-color: black;
		position: relative;
	}

	.timeline-list li:hover {
		color: var(--brand-primary-color);
		border-color: var(--brand-primary-color);
		background-color: var(--brand-primary-color-faded);
	}

	.timeline-list li:hover .line {
		background-color: var(--brand-primary-color);
		color: var(--brand-primary-color);
	}

	.timeline-list li .fa-minus {
		text-align: center;
	}

	.timeline-list li .fa-circle {
		position: absolute;
		top: -8px;
		left: 0;
		right: 0;
		width: 15px;
		margin: auto;
		color: var(--brand-primary-color);
	}

	.timeline-list .timeline-day,
	.timeline-list .timeline-block {
		vertical-align: top;
		padding: 5px;
	}

	.timeline-list .timeline-block span {
		text-align: center;
	}

	.timeline-list li .fa-ellipsis-h {
		position: relative;
		top: -5px;
		width: 30px;
		text-align: center;
	}

	.timeline-list .timeline-block span {
		color: inherit;
		top: 15px;
		left: 7px;
	}

	.timeline-list li .timeline-block span {

	}
</style>